import { render, staticRenderFns } from "./YesNoModalComponent.vue?vue&type=template&id=66024742&"
import script from "./YesNoModalComponent.vue?vue&type=script&lang=ts&"
export * from "./YesNoModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66024742')) {
      api.createRecord('66024742', component.options)
    } else {
      api.reload('66024742', component.options)
    }
    module.hot.accept("./YesNoModalComponent.vue?vue&type=template&id=66024742&", function () {
      api.rerender('66024742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/YesNoModalComponent.vue"
export default component.exports